
import { Component, Mixins } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import Hero from '@/components/Hero.vue';
import ContentBlocks from '@/components/content/ContentBlocks.vue';
import CmsContentMixin from '@/mixins/CmsContentMixin';
import DashboardOrdersBlock from '@/components/dashboard/DashboardOrdersBlock.vue';
import DashboardInvoicesBlock from '@/components/dashboard/DashboardInvoicesBlock.vue';
import DashboardMultinationalSectionCta from '@/components/dashboard/DashboardMultinationalSectionCta.vue';
import AuthGroup from '@/logic/auth/AuthGroup';
import Onboarding from '@/components/onboarding/Onboarding.vue';

@Component({
  components: {
    LayoutDefault,
    Hero,
    ContentBlocks,
    DashboardOrdersBlock,
    DashboardInvoicesBlock,
    DashboardMultinationalSectionCta,
    Onboarding,
  },
})
export default class Dashboard extends Mixins(CmsContentMixin) {
  get multinationalDashboard(): boolean {
    return this.$store.getters['auth/memberOf'](AuthGroup.Multinational);
  }

  get hasMfa(): boolean {
    return this.$store.getters['auth/hasMfa'];
  }

  get fullName(): string {
    return this.$store.getters['profile/fullName']
      ? ` ${this.$store.getters['profile/fullName']}`
      : '';
  }

  get customerName(): string {
    let customerName = ` ${this.$store.getters['profile/getSapCompany']}`;

    if (this.$store.getters['profile/getSapCompany'] === '-') {
      customerName = '';
    }

    return customerName;
  }

  created() {
    this.fetchDashboardContent();
  }

  async fetchDashboardContent() {
    try {
      this.isLoading = true;
      await this.fetchContent();
    } finally {
      this.isLoading = false;
    }
  }

  get hasAccessOrders(): boolean {
    return this.$store.getters['auth/hasAccess']({
      action: 'GET',
      resource: '/orders',
    });
  }

  get hasAccessInvoices(): boolean {
    return this.$store.getters['auth/hasAccess']({
      action: 'GET',
      resource: '/invoices',
    });
  }
}
